import axios from 'axios';
import Toast from '../helpers/Toast';

let tokenName = 'rh-bearer';

export function getToken() {
    return localStorage.getItem(tokenName);
}


export function storeToken(newToken) {
    localStorage.setItem(tokenName, newToken);
}

export function removeToken() {
    localStorage.removeItem(tokenName);
}

let axiosInstance = axios.create({
    baseURL: import.meta.env.VITE_APP_API_URL,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    }
});

axiosInstance.interceptors.request.use(
    config => {
        const token = getToken();
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

export function catchError(error) {
    if (error.response) {
        if (error.response.status === 401) {
            localStorage.removeItem(tokenName);
            if (!window.location.href.includes('/authentificate') && !window.location.href.includes('/error') && !window.location.href.includes('/login')) {
                window.location.href = '/login';
            }
        } else {
            if (error.response.data) {
                if (error.response.data.validation) {
                    let errors = error.response.data.errors;
                    for (let key in errors) {
                        Toast.error(errors[key][0]);
                        break;
                    }
                } else if (error.response.data.message) {
                    Toast.error(error.response.data.message);
                } else {
                    Toast.error('Une erreur est survenue');
                }
            } else {
                Toast.error('Une erreur est survenue');
            }
        }
    } else {
        throw error;
    }
}

class DaoService {

    prefix = '';

    static getInstance(prefix) {
        let service = new this();
        service.setPrefix(prefix);
        return service;
    }

    setPrefix(prefix) {
        this.prefix = prefix;
        return this;
    }

    async find(idOrUid) {
        const responseData = await axiosInstance.get(`${this.prefix}/${idOrUid}`);
        return responseData.data;
    }

    async findAll() {
        const responseData = await axiosInstance.get(`${this.prefix}`);
        return responseData.data;
    }

    async create(data) {
        const responseData = await axiosInstance.post(`${this.prefix}`, data);
        return responseData.data;
    }

    async update(idOrUid, data) {
        const response = await axiosInstance.put(`${this.prefix}/${idOrUid}`, data);
        return response.data;
    }

    async remove(idOrUid) {
        const response = await axiosInstance.delete(`${this.prefix}/${idOrUid}`);
        return response.data;
    }

    async partialUpdate(idOrUid, data) {
        const response = await axiosInstance.patch(`${this.prefix}/${idOrUid}`, data);
        return response.data;
    }

    static async upload(url, formData, onUploadProgress) {
        const response = await axiosInstance.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            onUploadProgress: progressEvent => {
                const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                onUploadProgress(percentCompleted); // Appel de la fonction de progression
            }
        });
        return response.data;
    }

    static async download(url) {
        const response = await axiosInstance.get(url, {
            responseType: 'blob'
        });
        return response.data;
    }

    static async get(url) {
        if (!url) {
            return null;
        }
        const response = await axiosInstance.get(url);
        return response.data;
    }

    static async post(url, data) {
        const response = await axiosInstance.post(url, data);
        return response.data;
    }

    static async put(url, data) {
        const response = await axiosInstance.put(url, data);
        return response.data;
    }

    static async delete(url) {
        const response = await axiosInstance.delete(url);
        return response.data;
    }
}

export { DaoService, axiosInstance };
